import { StringSchema } from 'yup';

export function emptyAsNull(this: StringSchema): any {
  return this.nullable().transform((value) => (!value ? null : value));
}
